import { type SearchResultFragment, useLinkConversationToInsuredMutation } from "@qw/graphql";
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, Icon, useToast } from "@qw/ui";
import { useCallback, useState } from "react";
import { LinkInsuredSearch } from "./link-insured-search";

export const LinkInsuredButton = ({ conversationId }: { conversationId: string }) => {
  const [open, setOpen] = useState(false);
  const { toast } = useToast();

  const [linkInsured] = useLinkConversationToInsuredMutation({
    refetchQueries: ["InboxConversation"],
  });

  const handleLinkInsured = useCallback(
    async ({ insuredId }: SearchResultFragment) => {
      const { data } = await linkInsured({ variables: { input: { conversationId, insuredId } } });
      const redirect = data?.linkConversationToInsured?.insuredLinkRedirect;
      if (redirect) {
        toast({ description: redirect.message });
      }
      setOpen(false);
    },
    [conversationId, linkInsured, toast]
  );

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="secondary" size="sm" className="gap-3 px-3 text-sm max-w-full">
          <Icon icon="database_search" />
          <span className="truncate">Link Insured to this Conversation</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        alignOffset={-1}
        side="bottom"
        sideOffset={-33}
        className="w-(--radix-dropdown-menu-trigger-width)"
      >
        <LinkInsuredSearch onSelect={handleLinkInsured} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
